export default __webpack_public_path__ + "static/media/kitchen5-afterE-1024w.d15a7faf.webp";